import React, { Fragment } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

type Hours = {
    closingTime: string | null;
    middayClosingTime?: string | null;
    middayOpeningTime?: string | null;
    openingTime: string | null;
};

type Props = {
    hours: Hours;
};

const OpeningHours = ({ hours }: Props) => {
    const { t } = useGranite();
    const openingHours = hours
        ? [
              hours.openingTime,
              hours.middayClosingTime,
              hours.middayOpeningTime,
              hours.closingTime,
          ]
              .filter(x => x)
              .join(" - ")
        : undefined;

    return (
        <Fragment>
            {openingHours ? (
                <p>{openingHours}</p>
            ) : (
                <p>{t("storePicker.storeInfo.label.closedToday")}</p>
            )}
        </Fragment>
    );
};

export default OpeningHours;
